import ListItemText from '@mui/material/ListItemText';

import { useTranslation } from '../../../../hooks';
import { RouteInfo } from '../../../../routes';
import { Box } from '../../../MuiGenerals';
import { isCurrentActiveMenuKey } from '../helper/currentActiveMenu';
import { StyledMenuItem } from '../styles/sx';
import { useSearchParams } from 'react-router-dom';

interface IMenuItemProps {
  title: string;
  routeInfo: RouteInfo;
  handleMenuItemClick: () => void;
  acceptLevel?: number;
}

const MenuItem = (props: IMenuItemProps) => {
  const { translate } = useTranslation();
  const { title, handleMenuItemClick, routeInfo, acceptLevel } = props;

  const [searchParams] = useSearchParams();
  const acceptLevelParam = searchParams.get('acceptLevel');

  const getSelected = () => {
    if (routeInfo.route === 'transactionRequest') {
      if (acceptLevel?.toString() === acceptLevelParam) {
        return true;
      }
    } else {
      return isCurrentActiveMenuKey(routeInfo.key);
    }
  };

  return (
    <Box>
      <StyledMenuItem selected={getSelected()} onClick={handleMenuItemClick}>
        <ListItemText>{title}</ListItemText>
      </StyledMenuItem>
    </Box>
  );
};

export default MenuItem;
